import React from 'react';
import styles from './Switch.module.css';
import {FormattedMessage} from "react-intl";

const Switch = ({ id, checked, onChange, labelLeft, labelRight, disabled = false }) => {
    const switchId = id || `switch-${crypto.randomUUID()}`; // Генерируем ID, если не передан

    return (
        <div className={`${styles.switchWrapper} ${disabled ? styles.disabled : ''}`}>
            {labelLeft && <span className={styles.label} onClick={!disabled ? onChange : undefined}>{labelLeft}</span>}
            <label className={styles.switchLabel} htmlFor={switchId}>
                <input
                    type="checkbox"
                    id={switchId}
                    className={styles.switchInput}
                    checked={checked}
                    onChange={!disabled ? onChange : undefined}
                    disabled={disabled}
                />
                <span className={styles.slider}></span>
            </label>
            {labelRight && <span className={styles.label} onClick={!disabled ? onChange : undefined}><FormattedMessage id={labelRight} /></span>}
        </div>
    );
};

export default Switch;
